import React, {useEffect, useState} from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    Divider,
    IconButton,
    ListItemIcon,
    Menu,
    MenuItem,
    MenuList,
    Theme,
    Typography,
    useMediaQuery
} from '@mui/material';
import {mostrarCompaniaDatosSinoEsta} from "../../redux/reducers/companiasReducers";
import {formatDate, formatPeso, geoString, hasModule, moment, translateText} from "../../helpers";
import {isMobile} from "../../helpers/browser_detect";
import makeStyles from '@mui/styles/makeStyles';
import {AttachFile, CheckBoxOutlineBlank, CheckBoxOutlined, MoreVert, Share} from "@mui/icons-material";
import {useLocation, useNavigate} from "react-router-dom";
import TopBarDialog from "../topBar/TopBarDialog";
//import SignatureCanvas from 'react-signature-canvas'
import Strings from "../../assets/strings";
import html2canvas from "html2canvas";

import {shareBase64} from "../../helpers/downloadFiles"
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {IPago, IPagoRecibo} from "../../redux/types/IPago";
import {reciboPagoPDF} from "./pdf";
import LoadingProgress from "../LoadingProgress";
import {reciboPagoPDFTicket} from "./pdfTicket";
import {getPagoById} from "../../services";
import {MODULO_USUARIO} from "../../helpers/CONSTANTES";
import openAdjunto from "../../helpers/openAdjunto";
import {TransZoom} from "../transitions";

const useStyles = makeStyles((theme:Theme) => ({
    root:{
        '@media print': {
                "&>div":{
                    background:"white",
                    width:"1020px",
                }
        }
    },
    askShare:{
        padding: 5,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxSizing: "border-box",
        '@media print': {
            display:"none"
        }
    },
    pagoPediente:{
        "&>div":{
            display:"flex",
            padding:theme.spacing(1),
            borderBottom: "1px solid #e6e6e6",
            "&>p:first-child":{
                fontWeight: 500,
                marginRight:theme.spacing(1)
            }
        }
    },
    sigCanvas:{
        touchAction: "none",
        position: "absolute",
        bottom: "-14px",
        right: "-18px"
    },
    close:{
        marginRight: "auto",
    },
    reciboPago: {
        minWidth: 1040,
        margin: "0 auto",
        padding: "20px 25px",
        fontFamily: "arial",
        fontSize: "14px",
        color: "#000",
        position: "relative",
        // outline: "2px solid",
        border: "2px solid",
        // outlineColor:theme.palette.primary.main,
        borderColor:theme.palette.primary.main,
        "&.aju":{
            // outlineColor:theme.palette.secondary.main,
            borderColor:theme.palette.secondary.main,
            "& h1": {
                color:theme.palette.secondary.main +"!important"
            },
        },
        "&:nth-child(2) ": {
            display:"none",
            position: "relative",
            marginTop: "70px",
            borderColor: "rgb(209, 209, 209)",
            outlineColor: "#aaaaaa",
            "&>:before": {
                content: '""',
                position: "absolute",
                top: "-37px",
                left: "0",
                width: "100%",
                borderBottom: "1px dashed"
            },
            '@media print': {
                display:"block",
            }
        },
        "& :not(i) span": {
            //paddingRight: "7px",
            fontWeight: "normal"
        },
        "&.small":{
            // border: "none",
            // outline: "none",
            // padding: 0,
            minWidth: 300,
            '& .topHead':{
                textAlign: "center",
                display: "block",
                height: "auto",
                '& .logo':{
                    textAlign: "center",
                    margin: "0 auto",
                    "& img":{
                        maxWidth: "73px",
                        maxHeight: "73px",
                    },
                },

                "& .info":{
                    "& h1":{
                        marginTop:4
                    },
                    "& *:not(h1)":{
                        fontSize: ".8rem",
                    }
                }
            },
            '& .header':{
                flexDirection: "column",
                "& h1":{
                    //order: 1,
                    textAlign: "center",
                    marginBottom: 14,
                    fontWeight: "normal",
                },
                "& .numero":{
                    //order: 2,
                    marginBottom: 8,
                },
                "& .fecha":{
                   // order: 3,
                    "& div.top":{
                        display: "initial",
                        borderBottom: "1px solid",
                        padding: "0px 10px",
                        "& span": {
                            padding: 3,
                            borderBottom: "none",

                        }
                    },

                    "& div.bottom":{
                        display:"none",
                    },

                },
            },
            '& section':{
                "& p":{
                    margin: "8px 0px",
                }
            },
            '& .desglose':{
                display: "block",
                "&>div":{
                    padding: 0,
                    border: "none",
                    marginBottom: 8,
                    "&>div":{
                        display: "inline-block",
                        marginRight: 13,
                        textTransform: "uppercase",
                    },
                }
            },
            '& .footer':{
                flexDirection: "column",
                alignItems: "baseline",
                "& .firma":{
                    margin: "0 auto",
                }
            },
        },
        // "&.small":{
        //     // border: "none",
        //     // outline: "none",
        //     // padding: 0,
        //     minWidth: 300,
        //     '& .topHead':{
        //         textAlign: "center",
        //         display: "block",
        //         height: "auto",
        //         '& .logo':{
        //             textAlign: "center",
        //             margin: "0 auto",
        //             "& img":{
        //                 maxWidth: "73px",
        //                 maxHeight: "73px",
        //             },
        //         },
        //
        //         "& .info":{
        //             "& h1":{
        //                 marginTop:4
        //             },
        //             "& *:not(h1)":{
        //                 fontSize: ".8rem",
        //             }
        //         }
        //     },
        //     '& .header':{
        //         flexDirection: "column",
        //         "& h1":{
        //             order: 1,
        //             textAlign: "center",
        //             fontSize: "1.5em",
        //             marginBottom: 14,
        //             fontWeight: "normal",
        //         },
        //         "& .numero":{
        //             order: 2,
        //             marginBottom: 8,
        //         },
        //         "& .fecha":{
        //             order: 3,
        //             "& div.top":{
        //                 display: "initial",
        //                 borderBottom: "1px solid",
        //                 padding: "0px 10px",
        //                 "& span": {
        //                     padding: 3,
        //                     borderBottom: "none",
        //
        //                 }
        //             },
        //
        //             "& div.bottom":{
        //                 display:"none",
        //             },
        //
        //         },
        //     },
        //     '& section':{
        //         borderTop: "1px dashed",
        //         paddingTop: 6,
        //         borderBottom: "1px dashed",
        //         paddingBottom: 6,
        //         marginBottom: 10,
        //
        //
        //       "& p":{
        //           margin: "8px 0px",
        //           "& span:last-child":{
        //               borderBottom:"none"
        //           }
        //       }
        //     },
        //     '& .desglose':{
        //         display: "block",
        //         "&>div":{
        //             padding: 0,
        //             border: "none",
        //             marginBottom: 4,
        //             "&>div":{
        //                 display: "inline-block",
        //                 marginRight: 13,
        //                 //textTransform: "uppercase",
        //                 "&:after":{
        //                     content: "':'"
        //                 }
        //             },
        //             "&>span":{
        //                 fontStyle: "italic"
        //             },
        //         }
        //     },
        //     '& .footer':{
        //         flexDirection: "column",
        //         alignItems: "baseline",
        //         "& .firma":{
        //             margin: "0 auto",
        //         }
        //     },
        // },
        "& .d-print-none":{
            opacity: 0.5,
        }
    },
    desglose:{
        display:"flex",
        "&>div":{
            position: "relative",
            marginRight: "18px",
            paddingLeft: "5px",
            borderLeft: "1px solid"
        }
    },
    topHead: {
        display: "flex",
        justifyContent: "space-between",
        textAlign: "right",
        height: "103px",
        "& h1":{
            color:theme.palette.primary.main,
            fontWeight: "normal",
            marginBottom: "0",
            fontSize: "1.3rem",
        },
        "& .logo":{
            maxWidth: 180,
            textAlign: "left",
            "& img":{
                maxWidth: "100%",
                maxHeight: "100%",
            },
        },
        "& span":{
            padding: 0,
            "&.tel":{
                fontSize:".8rem",
            },
            "&.dir":{
                fontSize:".7rem",
            }
        }
    },
    header:{
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "20px",
        "& .numero": {
            fontWeight: "bold",
            "& span": { borderBottom: "1px solid", padding: "0px 7px", fontWeight: "normal" }
        },
        "& h1": { margin: "0", fontSize: "1.2em", color:theme.palette.primary.main },
        "& div.fecha": {
            "& div.top": {
                "& span":{
                    borderBottom: "1px solid",
                    padding: "0 7px",
                }
            },
            "& div.bottom": {
                fontSize: ".8em",
                fontStyle: "italic",
                "& span":{
                    padding: "0 9px",
                }
            },

        }
    },
    section: {
        marginBottom: 1,
        "& p": {
            fontSize: 14,
            display: "flex",
            "& span": {
                fontWeight: "bold",

                "&:last-child, &.suma": {
                    fontWeight: "normal",
                    borderBottom: "1px solid #ccc",
                    padding: "0px 7px",
                    flex: 12,
                },

                "&.suma": {
                    flex: 70,
                }
            },
            "&.cRestante": {
                textAlign: "right",

                "& span": {
                    width: 134,
                    textAlign: "left",
                }
            }
        }
    },
    content:{
        background:"white",
        padding:0,
        '@media print': {
            overflow: 'visible',
            margin:0,
        }
    },
    footer: {
        marginTop:16,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& .firma": {
            marginTop: -14,//53,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",

            "& .imgCont": {
                textAlign: "center",
                height: 69,
                "& img": {
                    height:"100%"
                },
            },
            "& span": {
                fontWeight: "bold",
                padding: "3px 90px",
                border: "none",
                borderTop: "1px solid"
            }
        }
    },
}));

interface IProps {
    toPreIcon?: boolean
}
export default function ReciboPago({toPreIcon}:IProps){
    let navigate = useNavigate();
    let dispatch = useAppDispatch();
    const [anchorElMenu, setAnchorElMenu] = React.useState<null | HTMLElement>(null);
    const [loading, setLoading] = useState(false)

    const {whatsappBot} = useAppSelector(state => state.theme);
    let generales = useAppSelector(state => state.companias.data ?? {});
    let firmaImg = useAppSelector(state => state.auth.user?.firma ?? "");



    const {state:urlState,pathname} = useLocation();

    const smVewport = useMediaQuery((theme:Theme)=>theme.breakpoints.down('md'));
    const classes = useStyles();

    const [dLarge] = useState(false)//!isMobile.anyWebView()
    const [reciboPdf,setReciboPdf] = useState("")
    const [reciboSize, setReciboSize] = useState<58|80|8.5>()

    const [data,setData] = useState<IPago | null>({
        id: 0,
        prestamoId: 0,
        cliente:"",
        fecha: "",
        interes: 0,
        capital: 0,
        descuento: 0,
        mora: 0,
        nuevoCapital: 0,
        balance: 0,
        comentario: "",
        totalLetra: "",
        tipo: 0,
        tipoFormaPago: undefined,
        concepto: "",
        cuotaPagadas: 0,
        balancePendiente: 0,
        capitalPendiente: 0,
        interesPendiente: 0,
        // fechaCreacion: "",
        fechaAnulacion: "",
    });

    // useEffect(()=>{
    //     if(whatsappBot){
    //         setDLarge(false)
    //     }
    // },[whatsappBot,setDLarge])


    useEffect(()=>{
            dispatch(mostrarCompaniaDatosSinoEsta());
        if(urlState?.recibo){
            setData(urlState.recibo);
            if(!urlState.recibo?.totalPago){
                getPagoById(urlState.recibo.id).then(res=>{
                    setData(res.data)
                })
            }

            // setNumeroContacto(urlState.recibo.clienteCelular ??"")
            // if(urlState?.recibo.tipo === 8) setDLarge(false);
        }else{
            setData(null);
            setReciboPdf("")
            setReciboSize(undefined)
            // setDLarge(!smVewport);
        }
    },[urlState?.recibo,setReciboPdf, setReciboSize, dispatch])

    // useEffect(()=>{
    //     if(reciboSize === undefined) return  setReciboPdf("") ;
    //     console.log("asdasd")
    //     if(data?.id && generales){
    //         setLoading(true)
    //         let doc = (reciboSize !== 8.5? reciboPagoPDFTicket(data, generales,reciboSize): reciboPagoPDF(data, generales));
    //         doc.then(pdfDocGenerator=>{
    //             pdfDocGenerator.getBase64((result) => {
    //               setReciboPdf("data:application/pdf;base64,"+result)
    //             })
    //         }).finally(()=>setLoading(false))
    //     }else{
    //         setReciboPdf("")
    //     }
    // },[data,generales, setReciboPdf, setLoading, reciboSize])


    const viewInvoiceSize = (reciboSize?:58|80|8.5) => {
        setAnchorElMenu(null)
        setReciboSize(reciboSize)
        if(reciboSize === undefined) return  setReciboPdf("") ;


        if(data?.id && generales){
            setLoading(true)
            let doc = (reciboSize !== 8.5? reciboPagoPDFTicket(data, generales,reciboSize): reciboPagoPDF(data, generales));
            doc.then(pdfDocGenerator=>{
                pdfDocGenerator.getBase64((result) => {
                    setReciboPdf("data:application/pdf;base64,"+result)
                })
            }).finally(()=>setLoading(false))
        }
        // else{
        //     setReciboPdf("")
        // }
    }

   // if(!data) return null;




    let formatoRecibo:string[];
    try {
        formatoRecibo = generales?.formatoRecibo?.split(",")??[];
    }
    catch(error) {
        formatoRecibo = []
    }
    const openShareMsj = (obj:any)=>{
        navigate(pathname, {state: {...urlState, contactar:{
                    id: data?.prestamoId,
                    nombres: data?.cliente,
                    celular: data?.clienteCelular??"",
                    email: data?.clienteEmail??"",
                    ...obj
                }}})
    }

    const convertHtml=(whatsapp?:boolean)=>{
        setAnchorElMenu(null);
      //  window.scrollTo(0,0);
      //   let fileName = "pago_" + data?.cliente?.replace(/\s/g, "-") + "_" + formatDate(data?.fecha, "DD,MMMM,YYYY") + "_#" + data?.id;

        let descripcion = `Saludos ${data?.cliente}, Su pago a sido aplicado exitosamente, Gracias.`

        if(!!reciboPdf){
            if(whatsapp){
                return openShareMsj({base64:reciboPdf, descripcion})



                // return socket.emit("sendMsg",{
                //     clientId:userId,
                //     number:numeroContacto,
                //     message:`Saludos ${data?.cliente}, Su pago a sido aplicado exitosamente, Gracias.`,
                //     base64:reciboPdf
                // })
            }

            shareBase64(reciboPdf, "Pago de "+data?.cliente, "pdf")
        }


        let el = document.querySelector(".reciboCont>div") as HTMLElement;
        if(el) {
            html2canvas(el, {
                scrollY: 0,
              //  letterRendering: 1,
                allowTaint: true,
                logging: true,
                useCORS: true,
                 scale:whatsapp ? 3: undefined,
                // width:1024


            }).then(canvas => {


                if(whatsapp){
                    let MAX_WIDTH = 1024;
                    let MAX_HEIGHT = 1024;

                    let width = canvas.width;
                    let height = canvas.height;

                    // Change the resizing logic
                    if (width > height) {
                        // if (width > MAX_WIDTH) {
                        height = height * (MAX_WIDTH / width);
                        width = MAX_WIDTH;
                        // }
                    } else {
                        // if (height > MAX_HEIGHT) {
                        width = width * (MAX_HEIGHT / height);
                        height = MAX_HEIGHT;
                        // }
                    }


                    let canvasResized = document.createElement("canvas");

                    canvasResized.setAttribute('width', width.toString());
                    canvasResized.setAttribute('height', height.toString());

                    let ctx = canvasResized.getContext('2d');

                    ctx!.drawImage(canvas, 0, 0, width, height);
                    //   var dataURL = extra_canvas.toDataURL();


                    let base64 = ctx!.canvas.toDataURL('image/jpeg', 1.0);


                    return openShareMsj({base64, descripcion})
                   // return socket.emit("sendMsg",{
                   //      clientId:userId,
                   //      number:numeroContacto,
                   //      message:`Saludos ${data?.cliente}, Su pago a sido aplicado exitosamente, Gracias.`,
                   //      base64
                   //  })
                }

                let base64 = canvas.toDataURL('image/jpeg', 1.0);



                shareBase64(base64, "Pago de "+data?.cliente, "jpg")
            });
        }
    }
    const imprimir = () => {
        setAnchorElMenu(null)

        if(generales){
            let {nombre,rnc, logo,direccion, telefono, telefono2, email,formatoRecibo,footerRecibo} = generales;
            let obj = {
                empresaLogo: logo ,
                empresaRNC: rnc ,
                empresaNombre: nombre ,
                empresaDireccion: direccion ,
                empresaTelefono: telefono ,
                empresaTelefono2: telefono2 ,
                empresaEmail: email ,
                formatoRecibo,
                footerRecibo,
                ...data,

            };
            let c_obj:IPagoRecibo = {
                ...obj,
                fecha: formatDate(obj.fecha)+" "+moment(obj.fecha).format("hh:mm a"),
                // fechaCreacion: formatDate(obj.fechaCreacion),
                fechaAnulacion: formatDate(obj.fechaAnulacion),
                fechaProximoPago: formatDate(obj.fechaProximoPago),
                balance: formatPeso(obj.balance),
                balancePendiente: formatPeso(obj.balancePendiente),
                capital: formatPeso(obj.capital),
                capitalPendiente: formatPeso(obj.capitalPendiente),
                comision: formatPeso(obj.comision),
                descuento: formatPeso(obj.descuento),
                interes: formatPeso(obj.interes),
                seguro: formatPeso(obj.seguro),
                otros: formatPeso(obj.otros),
                interesPendiente: formatPeso(obj.interesPendiente),
                mora: formatPeso(obj.mora),
                nuevoCapital: formatPeso(obj.nuevoCapital),
                totalPago: formatPeso(obj.totalPago),


                id: data?.id!,
                prestamoId: data?.prestamoId!,
                cliente: data?.cliente ?? "",
                comentario: data?.comentario ?? "",
                totalLetra: data?.totalLetra ?? "",
                tipo: data?.tipo ?? 1,
                tipoFormaPago: data?.tipoFormaPago ?? 1,
                formaPagoString: data?.formaPagoString ?? "",
                concepto: data?.concepto ?? "",
                cuotaPagadas: data?.cuotaPagadas ?? 0,
                usuarioCreadoPor: data?.usuarioCreadoPor ?? "",

            }

            if((window as any).ReactNativeWebView ){

                let ms = {
                    action: "reciboPago",
                    payload:  c_obj
                }

                return (window as any).ReactNativeWebView.postMessage(JSON.stringify(ms))

            }else if((window as any).webkit?.messageHandlers?.printAPP){
                return (window as any).webkit?.messageHandlers?.printAPP?.postMessage(c_obj);

            }else if((window as any).Android?.downloadFromBase64){
                return  (window as any).Android?.printAPP(JSON.stringify(c_obj));

            }



            // window.print()
        }
    };


    return(
        <>
            <Dialog //Boolean(data?.cliId > 0)
                // TransitionComponent={TransZoom}
                open={Boolean(data?.id)}
                maxWidth={reciboSize===8.5?"lg":"xs"}
                fullWidth={true}
                onClose={()=>navigate(-1)}
                fullScreen={smVewport}
                className="dialogRecibo"
                classes={{root:classes.root}}
            >
                <TopBarDialog title={Strings.recibo} onClose={()=> navigate(pathname,{replace:true})} >


                    {(whatsappBot || hasModule(MODULO_USUARIO.enviarCorreo))  &&
                        <IconButton sx={{color:"white"}}  onClick={()=>convertHtml(true)}
                        >
                            <Share fontSize={"small"} sx={{color:"white"}}  />
                        </IconButton>
                    }

                    {!!data?.adjunto &&
                        <IconButton data-fancybox sx={{color:"white"}} onClick={()=>openAdjunto(data?.adjunto!)}>
                            <AttachFile fontSize={"small"}  />
                            {/*eliminar plural hardcode*/}
                            {/* {Strings.ver} {Strings.adjuntos.slice(0, -1)} */}
                        </IconButton>

                    }

                    {data?.tipo !== 8 &&
                    <>
                        <IconButton
                            aria-controls={Boolean(anchorElMenu) ? 'basic-menu' : undefined}
                            aria-haspopup="true"
                            aria-expanded={Boolean(anchorElMenu) ? 'true' : undefined}
                            onClick={(event) =>  setAnchorElMenu(event.currentTarget)}
                        >
                            <MoreVert sx={{color:"white"}} />
                        </IconButton>
                        <Menu
                            id="basic-menu"
                            anchorEl={anchorElMenu}
                            open={Boolean(anchorElMenu)}
                            onClose={()=>setAnchorElMenu(null)}
                            MenuListProps={{
                                'aria-labelledby': 'basic-button',
                            }}
                        >
                            <MenuList>
                                {!isMobile.AndroidWebView() &&
                                    <MenuItem onClick={()=>viewInvoiceSize(reciboSize === 8.5? undefined: 8.5)}>
                                        <ListItemIcon>
                                            {reciboSize === 8.5? <CheckBoxOutlined />:<CheckBoxOutlineBlank />}
                                        </ListItemIcon>
                                        {Strings.ver + " (8.5 x 11)"}
                                    </MenuItem>
                                }
                                {!isMobile.anyWebView() &&
                                    <MenuItem onClick={()=>viewInvoiceSize(reciboSize === 58? undefined: 58)}>
                                        <ListItemIcon >
                                            {reciboSize === 58? <CheckBoxOutlined />:<CheckBoxOutlineBlank />}
                                        </ListItemIcon>
                                        {Strings.ver + " (58mm)"}</MenuItem>
                                }
                                {!isMobile.anyWebView() &&
                                    <MenuItem onClick={()=>viewInvoiceSize(reciboSize === 80? undefined: 80)}>
                                        <ListItemIcon>
                                            {reciboSize === 80? <CheckBoxOutlined />:<CheckBoxOutlineBlank />}
                                        </ListItemIcon>
                                        {Strings.ver + " (80mm)"}</MenuItem>
                                }
                                <Divider/>
                                {isMobile.anyWebView() &&
                                    <MenuItem onClick={()=>imprimir()}>{Strings.imprimir}</MenuItem>


                                }

                                <MenuItem onClick={()=>convertHtml()}>{isMobile.anyWebView() ? Strings.compartir : Strings.descargar}</MenuItem>
                                {!!toPreIcon && <MenuItem onClick={()=>navigate(`/prestamo/${data?.prestamoId}`)}>{Strings.ver + " " + Strings.prestamo}</MenuItem>}

                                <MenuItem onClick={()=>navigate("/ajustes#recibo")}>{Strings.ajustes}</MenuItem>


                            </MenuList>
                        </Menu>
                    </>
                        // <ButtonSelect smIcon={<MoreVert sx={{color:"white"}} />}
                        //               opcions={[
                        //                   {key: "", value: Strings.opciones, disabled: true},
                        //                   // ...(isMobile.anyWebView() || dLarge ? [{
                        //                   //     key: "1",
                        //                   //     value: Strings.imprimir
                        //                   // }] : []),
                        //                   {key: "8.5", value: (reciboSize===8.5?" ✓ ":"")+Strings.ver + " (8.5 x 11)"},
                        //
                        //                   ...(!isMobile.anyWebView() ? [
                        //                       {key: "58", value: (reciboSize===58?" ✓ ":"")+Strings.ver + " (58mm)"},
                        //                       {key: "80", value: (reciboSize===80?" ✓ ":"")+Strings.ver + " (80mm)"},
                        //                       {key: "--1", value: "-"},
                        //                   ] : []),
                        //                   {
                        //                       key: "2",
                        //                       value: isMobile.anyWebView() ? Strings.compartir : Strings.descargar
                        //                   },
                        //                   // {key: "3", value: dLarge ? Strings.vertical : Strings.horizontal},
                        //
                        //                   ...(toPreIcon ? [{
                        //                       key: "4",
                        //                       value: Strings.ver + " " + Strings.prestamo
                        //                   }] : []),
                        //                   {key: "5", value: Strings.ajustes}]}
                        //               onChange={(v) => {
                        //                   switch (v) {
                        //                       case "1":
                        //                           imprimir()
                        //                           break
                        //                       case "8.5":
                        //                           viewInvoiceSize(reciboSize === 8.5? undefined: 8.5)
                        //                           break
                        //                       case "58":
                        //                           viewInvoiceSize(reciboSize === 58? undefined: 58)//convertPDF(58)
                        //                           break
                        //                       case "80":
                        //                           viewInvoiceSize(reciboSize === 80? undefined: 80)//convertPDF(80)
                        //                           break
                        //                       case "2":
                        //                           convertHtml()
                        //                           break
                        //                       case "3":
                        //                           setDLarge(!dLarge)
                        //                           break
                        //                       case "4":
                        //                           navigate(`/prestamo/${data?.prestamoId}`)
                        //                           break
                        //                       case "5":
                        //                           navigate("/ajustes#recibo")
                        //                           break
                        //                       default:
                        //                           return false
                        //                   }
                        //               }}
                        // />
                    }

                </TopBarDialog>
                <DialogContent className={classes.content}>
                    {loading && <LoadingProgress/>}

                    {/*{askShare &&*/}
                    {/*    <Box className={classes.askShare}>*/}
                    {/*        <Typography sx={{mr:1}} >ENVIAR RECIBO A:</Typography>*/}
                    {/*        <TextField*/}
                    {/*            value={numeroContacto??""}*/}
                    {/*            onChange={({target})=>setNumeroContacto(target.value)}*/}
                    {/*        />*/}
                    {/*            <Button onClick={()=>convertHtml(true)}>Enviar</Button>*/}
                    {/*    </Box>*/}
                    {/*}*/}

                    {data?.tipo === 8?(
                            <div className={classes.pagoPediente}>
                                <Box>
                                    <Typography>{Strings.prestamo} ID:</Typography>
                                    <Typography>{"preReferencia"}</Typography>
                                </Box>
                                <Box>
                                    <Typography>{Strings.cliente}:</Typography>
                                    <Typography>{data?.cliente}</Typography>
                                </Box>
                                <Box>
                                    <Typography>{Strings.fecha}</Typography>
                                    <Typography>{formatDate(data?.fecha)}</Typography>
                                </Box>
                                <Box sx={{flexDirection: "column"}}>
                                    <Typography>{Strings.comentario}</Typography>
                                    <Typography>{data?.comentario}</Typography>
                                </Box>
                                <Box>
                                    <Typography>{Strings.total}</Typography>
                                    <Typography>{formatPeso(data?.totalPago)}</Typography>
                                </Box>

                                <Button fullWidth onClick={()=>navigate(`/prestamo/${data?.prestamoId}`)}>{Strings.ver} {Strings.prestamo}</Button>
                            </div>
                    ):(
                        <>
                            {reciboPdf? (
                                <iframe src={reciboPdf} title={"recibo"} style={{width:"99%", height:"calc(100vh - 199px)"}}/>
                            ):(
                                <div className={"reciboCont"}>
                                    {[...Array(formatoRecibo.includes("copia") && dLarge ?2:1).keys()].map(i=>
                                        <div key={i} className={classes.reciboPago + (!dLarge?" small ":" ")+(data?.tipo===4?"aju":"")}>
                                            {!!data?.fechaAnulacion &&
                                                <Box sx={{
                                                    color: "red",
                                                    fontSize: 73,
                                                    position: "absolute",
                                                    transform: "rotate(304deg)",
                                                    opacity: 0.2,
                                                    top: "40%",
                                                    left: 72,
                                                }}>{Strings.anulado}</Box>
                                            }

                                            <div className={"topHead " +classes.topHead}>
                                                <div className="logo">
                                                    {generales.logo &&
                                                        <img alt="logo" src={generales.logo} />
                                                    }
                                                </div>
                                                <div className="info">
                                                    <h1>{generales.nombre}</h1>
                                                    <span className="tel">
                                                <i>
                                                    {!!generales.rnc && <><span>{geoString("rnc",true)}: {generales.rnc}</span> <br/></>}
                                                    {!!generales.telefono && <span> Tel: {generales.telefono}</span>}
                                                    {!!generales.telefono2 && <span> &nbsp;/ &nbsp; {generales.telefono2}</span>}
                                                </i>
                                            </span>
                                                    <br/>
                                                    <span className="dir">{generales.direccion}</span>

                                                </div>
                                            </div>
                                            <br />
                                            <div className={"header " +classes.header}>
                                                <h1>{(data?.tipo===4?Strings.ajusteCapital+"/"+Strings.reenganche:Strings.reciboDePago).toLocaleUpperCase()}</h1>

                                                <Box display={"flex"} justifyContent={"space-between"}>
                                                    <div className="numero">{!dLarge && <>Recibo </>} No. <span>{data?.id}</span></div>

                                                    <div className="fecha">
                                                        <strong>{Strings.fecha}: &nbsp;</strong>
                                                        <span style={{borderBottom: "1px solid"}}>
                                                                <span>{formatDate(data?.fecha,"DD")}</span> /
                                                                <span> {formatDate(data?.fecha,"MM")}</span> /
                                                                <span> {formatDate(data?.fecha,"YYYY")} </span>
                                                            {/*{formatDate(data?.fecha)} */}
                                                            <small> {moment(data?.fecha).format("hh:mm a")} </small>

                                                        </span>

                                                        {/*<div className={"top"}>*/}
                                                        {/*    <span>{formatDate(data?.fecha,"DD")}</span> /*/}
                                                        {/*    <span>{formatDate(data?.fecha,"MM")}</span> /*/}
                                                        {/*    <span>{formatDate(data?.fecha,"YYYY")}</span>*/}
                                                        {/*    <span><small> {moment(data?.fecha).format("hh:mm a")}</small></span>*/}

                                                        {/*</div>*/}
                                                        {/*<div className={"bottom"}>*/}
                                                        {/*    <span>{Strings.dia}</span>*/}
                                                        {/*    <span>{Strings.mes}</span>*/}
                                                        {/*    <span>{Strings.anio}</span>*/}
                                                        {/*</div>*/}
                                                    </div>
                                                </Box>

                                            </div>
                                            <section className={classes.section}>
                                                <p><span>{(data?.tipo===4?Strings.entregadoA:Strings.recibido+" "+Strings.de ).toLocaleUpperCase()}:</span> <span><b>{data?.cliente}</b></span></p>
                                                <p><span>MONTO TOTAL:</span>
                                                    {dLarge && <><span className="suma">{data?.totalLetra}</span><span>{Strings.monto.toLocaleUpperCase()}:</span></> }
                                                    <span> {formatPeso(data?.totalPago)}</span>
                                                </p>
                                                <p><span>{"CONCEPTO"}:</span> <span style={{width: "82.6%", display: "inline-block"}}>{data?.concepto}</span></p>
                                                {!!data?.comentario &&
                                                    <p><span>{Strings.comentario.toLocaleUpperCase()}:</span> <span>{data?.comentario}</span></p>
                                                }
                                            </section>
                                            <div className={"footer " +classes.footer}>
                                                <div className={"desglose " + classes.desglose}>

                                                    {formatoRecibo.includes("tipoFormaPago") && !!data?.formaPagoString &&
                                                        <div>
                                                            <Box>{Strings.tipoFormaPago}:</Box>
                                                            <span className="c">{translateText(data?.formaPagoString)}</span>
                                                        </div>}
                                                    {formatoRecibo.includes("agente") && !!data?.usuarioCreadoPor &&
                                                        <div>
                                                            <Box>{Strings.cobrador}:</Box>
                                                            <span className="c">{data?.usuarioCreadoPor}</span>
                                                        </div>
                                                    }
                                                    {data?.tipo !== 10 && <>
                                                        {data?.tipo !== 4 && <>
                                                            {formatoRecibo.includes("capital") &&
                                                                <div>
                                                                    <Box>{Strings.capital}:</Box>
                                                                    <span className="c">{formatPeso(data?.capital)}</span>
                                                                </div>}

                                                            {formatoRecibo.includes("interes") &&
                                                                <div>
                                                                    <Box>{Strings.interes}:</Box>
                                                                    <span className="c">{formatPeso(data?.interes)}</span>
                                                                </div>}
                                                            {formatoRecibo.includes("seguro") && !!data?.seguro &&
                                                                <div>
                                                                    <Box>{Strings.seguro}:</Box>
                                                                    <span className="c">{formatPeso(data?.seguro)}</span>
                                                                </div>}
                                                            {formatoRecibo.includes("otros") && !!data?.otros &&
                                                                <div>
                                                                    <Box>{Strings.otros}:</Box>
                                                                    <span className="c">{formatPeso(data?.otros)}</span>
                                                                </div>}
                                                            {formatoRecibo.includes("descuento") &&
                                                                <div>
                                                                    <Box>{Strings.descuento}:</Box>
                                                                    <span className="c">{formatPeso(data?.descuento)}</span>
                                                                </div>}
                                                            {formatoRecibo.includes("mora") &&
                                                                <div style={{color: "#de5c5c"}}>
                                                                    <Box>{Strings.mora}:</Box>
                                                                    <span className="c">{formatPeso(data?.mora)}</span>
                                                                </div>}
                                                        </>}




                                                        {formatoRecibo.includes("capitalRestante") &&
                                                            <div>
                                                                <Box>{Strings.capitalPendiente}:</Box>
                                                                <span className="c">{formatPeso(data?.nuevoCapital)}</span>
                                                            </div>}
                                                        {formatoRecibo.includes("balancePendiente") &&
                                                            <div>
                                                                <Box>{Strings.balancePendiente}:</Box>
                                                                <span className="c">{formatPeso(data?.balance)}</span>
                                                            </div>}
                                                        {formatoRecibo.includes("proximoPago") &&
                                                            <div>
                                                                <Box>{Strings.proximo} {Strings.pago}:</Box>
                                                                <span
                                                                    className="c">{formatDate(data?.fechaProximoPago)}</span>
                                                            </div>}
                                                    </>
                                                    }
                                                </div>
                                                {formatoRecibo.includes("firma") &&
                                                    <div className="firma">
                                                        <div className="imgCont">
                                                            {firmaImg &&
                                                                <img src={firmaImg} alt=""/>
                                                            }
                                                        </div>
                                                        {/*<SignatureCanvas penColor='black'*/}
                                                        {/*                 canvasProps={{width: 310, height: 100, className: classes.sigCanvas}} />*/}
                                                        <span>{Strings.firma.toLocaleUpperCase()}</span>
                                                    </div>}
                                                {generales.footerRecibo && !dLarge &&
                                                    <p style={{textAlign:"center",width: "100%"}}>{generales.footerRecibo}</p>
                                                }
                                            </div>
                                            <Box textAlign={"center"} fontSize={11}>
                                                {hasModule(MODULO_USUARIO.ocultarPieRecibo)? "": "PrestamistApp.com"}
                                            </Box>
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </DialogContent>

            </Dialog>
        </>
    )
}
